import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';

import { VODCSSModules, VODBiEvents } from 'shared/utils/wix-connect';
import runOnce from 'shared/utils/run-once';
import { LinkButton } from 'shared/components/button/button';
import Icon from 'shared/components/icon/icon';
import { isChannelInfoVisible } from 'shared/utils/layout-helpers';

import styles from './channel-actions.styl';


@connect(state => ({
  isVisible: isChannelInfoVisible(state.appSettings),
}))
@VODBiEvents()
@VODCSSModules(styles)
export default class ChannelInfoButton extends React.Component {

  static propTypes = {
    isVisible: React.PropTypes.bool,
    channelData: React.PropTypes.object,
    className: React.PropTypes.string,
    onClick: React.PropTypes.func,
    biEvent: React.PropTypes.func,
    dataHook: React.PropTypes.string,
  };

  componentDidMount() {
    this.sendAboutInfoDisplayedBI();
  }

  componentDidUpdate() {
    this.sendAboutInfoDisplayedBI();
  }

  sendAboutInfoDisplayedBI() {
    if (this.props.isVisible) {
      this.doSendAboutInfoDisplayedBI();
    }
  }

  @runOnce
  doSendAboutInfoDisplayedBI() {
    this.props.biEvent('widget.aboutCh.displayed');
  }

  sendClickedBI() {
    this.props.biEvent('widget.aboutCh.clicked');
  }

  @autobind
  handleClick(event) {
    this.sendClickedBI();
    this.props.onClick(event);
  }

  render() {
    const { className, isVisible, dataHook } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <LinkButton className={`qa-info-button ${className}`}
                  styleName="action info"
                  data-hook={dataHook}
                  onClick={this.handleClick}>
        <Icon styleName="back-button"
              name="info-1" />
      </LinkButton>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/channel-actions/channel-info-button.js